import usePlotRiskAssessment, {
  PlotRiskAssessmentStatus,
} from '../../../hooks/usePlotRiskAssessments';
import useValidatedSearchParams from '../../../router/useValidatedSearchParams';
import RiskAssessment, {
  RiskAssessmentFormData,
} from '../../../shared/components/RiskAssessment/RiskAssesssment';
import { Plot } from '../../../shared/types';

const PLOT_RISK_OPTIONS: PlotRiskAssessmentStatus[] = [
  'NEW',
  'UNDER_REVIEW',
  'IN_RISK_MITIGATION',
  'EUDR_COMPLIANT',
  'EUDR_NON_COMPLIANT',
];

const PlotRiskAssessment = (plot: Plot) => {
  const { createAssessment, updateAssessment } = usePlotRiskAssessment();
  const {
    setValidatedParam,
    SEARCH_PARAMS_KEYS: { RISK_MODAL },
  } = useValidatedSearchParams();

  const onSuccess = () => {
    setValidatedParam(RISK_MODAL, null);
  };

  const handleSubmit = (
    formData: RiskAssessmentFormData<PlotRiskAssessmentStatus>
  ) => {
    if (plot?.riskAssessment?.id) {
      updateAssessment.mutate(
        { ...formData, id: plot.riskAssessment.id },
        { onSuccess }
      );
    } else {
      createAssessment.mutate({ ...formData, plotId: plot.id }, { onSuccess });
    }
  };

  return (
    <RiskAssessment<PlotRiskAssessmentStatus>
      assessment={plot?.riskAssessment}
      onSubmit={handleSubmit}
      options={PLOT_RISK_OPTIONS}
      loading={updateAssessment.isLoading || createAssessment.isLoading}
    />
  );
};

export default PlotRiskAssessment;
